const ZH_CN = ['ç§', 'åé', 'å°æ¶', 'å¤©', 'å¨', 'ä¸ªæ', 'å¹´'];

export default function (diff: number, idx: number): [string, string] {
    if (idx === 0) return ['åå', 'çå»å'];
    const unit = ZH_CN[~~(idx / 2)];
    return [`${diff} ${unit}å`, `${diff} ${unit}å`];
}
